import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Scalars } from '@graphql/generated-contentful/graphql';
import { Maybe } from '@lib/types/Maybe';
import c from 'classnames';

import { RichText } from 'ui-components';

type BlocksTitleProps = {
  title?: Maybe<string>;
  description?: Scalars['JSON']['output'];
  text?: Scalars['JSON']['output'];
  isDarkTheme?: boolean;
};
export const BlocksTitle = ({
  title,
  description,
  text,
  isDarkTheme = false,
}: BlocksTitleProps) => {
  if (text) {
    const textHtml = documentToHtmlString(text?.json);
    let textHtmlWithLinebreaks = textHtml.replaceAll('<p></p>', '</br>');

    // remove the last occurrence of <br> to avoid excess bottom spacing
    if (textHtmlWithLinebreaks.endsWith('</br>')) {
      textHtmlWithLinebreaks = textHtmlWithLinebreaks.slice(0, -5);
    }

    return (
      <div className={c({ 'text-white': isDarkTheme })}>
        <RichText html={textHtmlWithLinebreaks} className="block [&_p]:mb-0" />
      </div>
    );
  }

  const descHtml = documentToHtmlString(description?.json);
  const descHtmlWithLinebreaks = descHtml.replaceAll('<p></p>', '</br>');

  return (
    <div className={c({ 'text-white': isDarkTheme })}>
      {title && (
        <h2 data-test="blocks-title" className="header-mid">
          {title}
        </h2>
      )}
      {description && (
        <RichText
          data-test="blocks-title-description"
          html={descHtmlWithLinebreaks}
          className="mt-5 block [&_p]:mb-0"
        />
      )}
    </div>
  );
};
